import {all, add} from './staticForms'

export default {all, add};